import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Envelope, MapPin, InstagramLogo, FacebookLogo, WhatsappLogo } from '@phosphor-icons/react';

const Footer = () => {
  return (
    <footer className="bg-[#030508] border-t border-border" data-testid="footer">
      <div className="container mx-auto px-8 md:px-16 lg:px-24">
        {/* Main Footer */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand Column */}
          <div className="md:col-span-4">
            <div className="flex items-center space-x-3 mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_fb7df63c-69aa-43b5-bde9-d9ace2d046d7/artifacts/83jahsha_file_000000001dd071fa989fc5a446c0d041.png"
                alt="TrueDroplet Water"
                className="h-14 w-auto"
                data-testid="footer-logo"
              />
              <div>
                <span className="block text-xl font-heading font-semibold tracking-wide text-foreground leading-none">TRUEDROPLET</span>
                <span className="block text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] leading-tight mt-1">Pure Water, Your Label</span>
              </div>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed max-w-xs" data-testid="footer-description">
              India's premium custom-labeled PET water bottle brand. We craft personalized water bottles for weddings, hotels, corporate events, and personal branding.
            </p>
            {/* Social Links */}
            <div className="flex items-center space-x-4 mt-6" data-testid="footer-social-links">
              <a href="https://www.instagram.com/truedroplet?igsh=bzUxZGp4MGZrM2hh" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-[#D4AF37] transition-colors" data-testid="social-instagram">
                <InstagramLogo size={24} weight="regular" />
              </a>
              <a href="https://www.facebook.com/share/1bnH6954Z8/" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-[#D4AF37] transition-colors" data-testid="social-facebook">
                <FacebookLogo size={24} weight="regular" />
              </a>
              <a href="https://wa.me/918549880305" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-[#D4AF37] transition-colors" data-testid="social-whatsapp">
                <WhatsappLogo size={24} weight="regular" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-2">
            <h4 className="text-sm uppercase tracking-[0.15em] text-foreground mb-5 font-body font-medium">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors" data-testid="footer-link-home">Home</Link></li>
              <li><Link to="/products" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors" data-testid="footer-link-products">Products</Link></li>
              <li><Link to="/contact" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors" data-testid="footer-link-contact">Contact Us</Link></li>
              <li><Link to="/orders" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors" data-testid="footer-link-orders">Track Order</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div className="md:col-span-3">
            <h4 className="text-sm uppercase tracking-[0.15em] text-foreground mb-5 font-body font-medium">Categories</h4>
            <ul className="space-y-3">
              <li><Link to="/products" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors" data-testid="footer-link-corporate">Corporate Bottles</Link></li>
              <li><Link to="/products" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors" data-testid="footer-link-wedding">Wedding Bottles</Link></li>
              <li><Link to="/products" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors" data-testid="footer-link-personal">Personal Bottles</Link></li>
              <li><Link to="/contact" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors" data-testid="footer-link-bulk">Bulk Orders</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="md:col-span-3">
            <h4 className="text-sm uppercase tracking-[0.15em] text-foreground mb-5 font-body font-medium">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3" data-testid="footer-phone">
                <Phone size={18} weight="regular" className="text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm text-slate-300">+91 85498 80305</p>
                  <p className="text-xs text-slate-500">Mon-Sat, 9AM - 7PM</p>
                </div>
              </li>
              <li className="flex items-start space-x-3" data-testid="footer-email">
                <Envelope size={18} weight="regular" className="text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <p className="text-sm text-slate-300">truedroplet@gmail.com</p>
              </li>
              <li className="flex items-start space-x-3" data-testid="footer-address">
                <MapPin size={18} weight="regular" className="text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <p className="text-sm text-slate-300 leading-relaxed">
                  TrueDroplet Water<br />
                  Tamalihalli, Jagalur,<br />
                  Davangere, Karnataka 577528
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-border/50 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500" data-testid="footer-copyright">
            &copy; 2026 TrueDroplet Water. All rights reserved. | truedroplet.com
          </p>
          <p className="text-xs text-slate-600">
            Premium Custom-Labeled PET Water Bottles
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
